module.exports = __webpack_public_path__ + "static/media/richang2.99fb54ad.jpg";